import moment from 'moment';
import PropTypes from 'prop-types';

import PersonFormComponent from '../Person/PersonFormComponent';

import { paginationOptions } from '../../staticData';
import { REACT_SELECT_INPUT, STYLED_TEXT } from '../Forms/fieldTypes';
import InfoComponent from '../Info';

const ContactInfoMessage = ({ contactInfo: { confirmationInfo } }) => {
  if (!confirmationInfo) {
    return null;
  }
  const duration = moment.duration(confirmationInfo.expires, 'seconds');
  const expiresString = `${duration.days()} days, ${duration.hours()} hours, and ${duration.minutes()} minutes`;
  return (
    <InfoComponent>
      <span>
        You recently updated your contact information. Please look for a message
        sent to&nbsp;
        <strong>{confirmationInfo?.contactInfo}</strong>&nbsp;to confirm your
        new contact info. This request will expire in&nbsp;
        {expiresString}
      </span>
    </InfoComponent>
  );
};
ContactInfoMessage.defaultProps = {
  contactInfo: {},
};

ContactInfoMessage.propTypes = {
  contactInfo: PropTypes.instanceOf(Object),
};

const CurrentUserFormComponent = (props) => {
  const title = 'Edit Profile';
  const additionalFormData = [
    {
      keyName: 'defaultPaginationLimit',
      label: 'Default Pagination Limit',
      fieldType: REACT_SELECT_INPUT,
      options: paginationOptions,
      validate: [],
      sortAlphabetically: false,
    },
    {
      keyName: 'pmcName',
      label: 'Property Management Company',
      fieldType: STYLED_TEXT,
      disabled: true,
      validate: [],
    },
  ];
  const {
    currentUser,
    onLoad,
    onSubmit,
    formValues,
    initialValues,
    formInitialValues,
  } = props;
  return (
    <>
      {currentUser.contactInfo.map((ci) => (
        <ContactInfoMessage contactInfo={ci} key={ci.type} />
      ))}
      <PersonFormComponent
        formValues={formValues}
        formInitialValues={formInitialValues}
        onSubmit={onSubmit}
        onLoad={onLoad}
        initialValues={initialValues}
        person={currentUser}
        title={title}
        personId={currentUser.id}
        additionalFormData={additionalFormData}
        isDisableSelectingExistingPerson
        isAlwaysEditable
      />
    </>
  );
};

CurrentUserFormComponent.defaultProps = {
  contactInfo: {},
};

CurrentUserFormComponent.propTypes = {
  initialValues: PropTypes.instanceOf(Object).isRequired,
  formValues: PropTypes.instanceOf(Object).isRequired,
  formInitialValues: PropTypes.instanceOf(Object).isRequired,
  currentUser: PropTypes.instanceOf(Object).isRequired,
  contactInfo: PropTypes.instanceOf(Object),
  onLoad: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default CurrentUserFormComponent;
